import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

const PricingPageHeader = ({ data }) => {
    const { cardItem, additionalConfiguration, backgroundColor, customId, id } = data || {};
    const { title, subtitle, media } = cardItem || {};
    const orderMediaText = String(additionalConfiguration?.contentOrder) === "Media/Text";
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration);
    return (
        <section
            data-section
            id={customId ?? id}
            className={` ${sectionPaddingClassName} ${sectionColorMapping.bgColor ||
                ""} pricing-banner-section relative overflow-hidden`}
        >
            <div className="container">
                <div
                    className={`${styles.pricingBanner} flex flex-col-reverse lg:flex-row lg:min-h-[377px] ${
                        orderMediaText ? "lg:flex-row-reverse" : ""
                    }`}
                >
                    <div className={`py-15 lg:pt-[66px] lg:pb-15 basis-7/12 `}>
                        {title && (
                            <h1
                                className="my-3.75"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                        )}
                        {subtitle && (
                            <p
                                className="text-xl mt-1.5 tracking-normal pt-4.75 font-light"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subtitle) }}
                            />
                        )}
                    </div>
                    <div
                        className={`media-element w-full flex h-full absolute top-0 right-0 -z-1 lg:relative basis-5/12 lg:min-h-[377px]  `}
                    >
                        {media?.[0] && (
                            <Media media={media[0]} className="w-full rounded-xs md:rounded" videoClassName="rounded" />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingPageHeader;
